import W2PSingleContent from 'components/MapoAdministration/components/Content-Management/W2PSingleContent';

const ScreenW2PSingleContent = () => {
  return <W2PSingleContent />;
};

export default ScreenW2PSingleContent;
